import { render, staticRenderFns } from "./RecipeItemStepCreate.vue?vue&type=template&id=d20bdf24&"
import script from "./RecipeItemStepCreate.vue?vue&type=script&lang=js&"
export * from "./RecipeItemStepCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports